// About the artist — a normal 100vh section in the document flow. The
// visitor scrolls down from the Opener and lands here naturally (native
// browser scroll, with `scroll-behavior: smooth` on <html> for polish).
// Big serif bio on the left, a rectangular painted cameo on the right,
// signature and on-display footnote below.
export default function AboutPanel({ gallery }) {
  const body = gallery.about_body || [];
  return (
    <section className="panel panel--about" data-testid="about-section">
      <div className="about__grain" aria-hidden="true" />

      <div className="about__inner">
        <div className="about__text">
          <p className="about__over mono-caps" data-testid="about-overline">
            {gallery.hero_overline}
          </p>
          <h2 className="about__headline" data-testid="about-headline">
            {gallery.about_headline}
          </h2>

          <div className="about__body" data-testid="about-body">
            {body.map((para) => (
              <p key={para.slice(0, 40)}>{para}</p>
            ))}
          </div>

          {gallery.about_footnote && (
            <p className="about__footnote mono-caps" data-testid="about-footnote">
              {gallery.about_footnote}
            </p>
          )}
        </div>

        <aside className="about__cameo" aria-hidden="true">
          <div
            className="about__cameo-frame"
            style={{
              "--cameo-src": `url(${gallery.about_image || gallery.hero_image})`,
            }}
          >
            <span className="about__cameo-noise" />
          </div>
        </aside>
      </div>
    </section>
  );
}
